import styled, { css } from "styled-components";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import Text from "common/Typography/Text";
import Title from "common/Typography/Title";
import AntCopyOutlined from "@ant-design/icons/CopyOutlined";
import Flex from "common/Boxes/Flex";
import { SMALL_TITLE_SCREEN } from "features/affiliation/common/constants";

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      /* Fields 16px apart; nothing trails the last one, so the modal's own
         padding is the space above the actions. */
      .ant-form-item {
        margin-bottom: 16px;
      }
      .ant-form > :last-child {
        margin-bottom: 0;
      }
    `}
`;

export const TableActionsEllipsisOutlined = styled(EllipsisOutlined)`
  cursor: pointer;
  font-size: 30px;
  transform: rotate(90deg);
`;

export const ActionsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SmallText = styled(Text).attrs({ type: "secondary" })`
  font-size: ${(p) => p.theme.typography.fontSizes.S};
`;

export const BoldTitle = styled(Title).attrs({ level: 3 })<{
  $isTablet?: boolean;
}>`
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  ${(p) =>
    p.$isTablet &&
    `
    font-size: ${p.theme.typography.fontSizes.M};
  `}
`;

export const BlueCopyOutlined = styled(AntCopyOutlined)`
  margin-right: 8px;
  color: ${(p) => p.theme.colors.primaryBlue};
`;

export const ValueTitle = styled(Title).attrs({ level: 1 })<{
  $longValue?: boolean;
}>`
  ${(p) =>
    p.$longValue &&
    `
    font-size: 26px;
`};

  @media (max-width: ${SMALL_TITLE_SCREEN}) {
    font-size: 20px;
  }
`;

export const CopyText = styled(Flex)`
  cursor: pointer;
  justify-content: start;
`;
